import React, {Component} from 'react';

class Unauthorized extends Component {


    constructor(props) {
        super(props);
        this.state = {style:{}}
    };

    componentDidMount() {
        setTimeout(function () {
            this.setState({style: {display:'none'}});
        }.bind(this),1000)
    }

    render() {
        let style = this.state.style;

        const Completionist = () => <span>You are good to go!</span>;

        const renderer = ({ total, days, hours, minutes, seconds, milliseconds, completed }) => {
            if (completed) {
                // Render a completed state
                return <Completionist />;
            } else {
                // Render a countdown
                return <div className="countdown">
                    <ul>
                        <li><span id="days" className="time digits">{days}</span><span
                            className="title">days</span></li>
                        <li><span id="hours" className="time digits">{hours}</span><span
                            className="title">Hours</span></li>
                        <li><span id="minutes" className="time digits">{minutes}</span><span
                            className="title">Minutes</span></li>
                        <li><span id="seconds" className="time digits">{seconds}</span><span
                            className="title">Seconds</span></li>
                    </ul>
                </div>;
            }
        };

        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var coundown = new Date(year , month, day+10).getTime();



        return (
            <div>
                <div className='loader-wrapper' style={style}>
                    <div className="loader bg-white">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <h4>Have a great day at work today <span>&#x263A;</span></h4>
                    </div>
                </div>
                 {/*Loader ends */}

                {/*page-wrapper Start*/}
                <div className="page-wrapper">
                    <div className="container-fluid p-0">
                        <div className="comingsoon auth-bg-video">
                            <video poster={require('../../assets/images/auth-bg.jpg')} className="bgvideo-comingsoon" id="bgvid"  autoPlay muted loop>
                                <source src={require('../../assets/video/auth-bg.mp4')} type="video/mp4"/>
                            </video>
                            <div className="comingsoon-inner text-left">
                                <div className="card">
                                    <div className="card-header text-center">
                                        <h4><i className="fa fa-exclamation-triangle"></i> Not Authorized</h4>
                                    </div>
                                    <div className="card-body">
                                        
                                    <div>You don't have permission to access this page.</div>
                                    <div>This could be due to:</div>
                                        <ul>
                                            <li><i className="fa fa-circle" style={{fontSize:"8px",color:"#888"}}></i> &nbsp;Insufficient privileges</li>
                                            <li><i className="fa fa-circle" style={{fontSize:"8px",color:"#888"}}></i> &nbsp;Expired session</li>
                                            <li><i className="fa fa-circle" style={{fontSize:"8px",color:"#888"}}></i> &nbsp;Accessing a restricted area</li>
                                        </ul>
                                        
                                    <a href={"/"}  className="btn btn-default">Go To Homepage</a>
                                    </div>
                                </div>
                                <div className="coming-soon-bottom-link">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*page-wrapper Ends*/}
            </div>
        )
    }
}


export default Unauthorized;
